import { render } from "./LegalMentions.vue?vue&type=template&id=6dc5d7c2&scoped=true&ts=true"
import script from "./LegalMentions.vue?vue&type=script&lang=ts"
export * from "./LegalMentions.vue?vue&type=script&lang=ts"

import "./LegalMentions.vue?vue&type=style&index=0&id=6dc5d7c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc5d7c2"]])

export default __exports__